import { useEffect, useState } from 'react';
import JunoButton from '../common/JunoButton';
import PropTypes from 'prop-types';

export default function Modal({ open, onClose, title, children, fullScreen }) {
    const [isVisible, setIsVisible] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
            setIsVisible(true);
            fullScreen ? setTimeout(() => setIsAnimating(true), 10) : setIsAnimating(true);
            return () => {
                document.body.style.overflow = 'unset';
            };
        } else if (isVisible) {
            // Animation and wait to close
            setIsAnimating(false);
            fullScreen ? setTimeout(() => setIsVisible(false), 500) : setIsVisible(false);
        }
    }, [open, isVisible, fullScreen]);

    const handleClose = () => {
        setIsAnimating(false);
        setTimeout(() => {
            setIsVisible(false);
            onClose();
        }, 1000);
    };

    if (!isVisible) return null;

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
            style={{ transitionDuration: '500ms' }}
            onClick={handleClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="FilterModal">
            <div
                className={`${
                    fullScreen ? 'w-full h-full' : 'w-[560px]'
                } bg-filterPannel-bg rounded-lg shadow-lg pt-4 px-3 relative transform transition-all ease-out ${
                    fullScreen
                        ? isAnimating
                            ? 'translate-y-0 opacity-100 scale-100'
                            : 'translate-y-full opacity-0 scale-100'
                        : ''
                }`}
                style={{ transitionDuration: '500ms' }}
                onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center px-1">
                    <h2 id="modal-title" className="text-lg !text-primary font-semibold">
                        {title}
                    </h2>
                    <JunoButton
                        type="custom"
                        onClick={handleClose}
                        className="!text-primary !w-auto !h-auto !px-0 !py-0 text-3xl hover:opacity-70">
                        &times;
                    </JunoButton>
                </div>
                <div className="mb-4 h-full">{children}</div>
            </div>
        </div>
    );
}

Modal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    fullScreen: PropTypes.bool,
};
